import React, { Component } from 'react'
import CSSTransition from 'react-transition-group/CSSTransition'

export default class AnimationAddRemove extends Component {
  constructor(props) {
    super(props)
    this.state = {
      added: props.show,
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.in && !this.props.show) {
      this.onEnter()
    }
  }
  onExited = () => {
    this.setState({
      added: false,
    })
  }
  onEnter = () => {
    this.setState({
      added: true,
    })
  }
  render() {
    const { added } = this.state
    const { children, ...otherProps } = this.props
    return (
      <CSSTransition
        onExited={this.onExited}
        style={added ? {} : { display: 'none' }}
        {...otherProps}
      >
        {children}
      </CSSTransition>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Animation/AnimationShowHide/AnimationShowHide.jsx